import React from 'react'
import * as Yup from 'yup'
import { HatchPattern, HatchPatternList } from './HatchPattern.jsx'
import { Button } from '@/components/UiElements'

const formView = (defaultValues, value) => [
  {
    name: 'id',
    type: 'Hidden',
  },
  {
    label: 'Add New Hatch Profile',
    hint: 'Create a new hatch profile to customize laser parameters for specific products.',
    type: 'Header',
    labelClassName: 'hidden',
    className: 'col-span-12',
    condition: (value) => !value?.id,
  },
  {
    name: 'divider',
    type: 'Divider',
    className: 'col-span-12',
    condition: (value) => !value?.id,
  },
  {
    label: '',
    hint: (
      <div className={'flex flex-col bg-yellow-50 rounded-md p-md mb-md text-yellow-700 relative gap-sm'}>
        <span className={'text-title-md'}>Please note:</span>Updating this hatch profile will affect all products that
        use this pattern. Proceed with caution.
      </div>
    ),
    headerClassName: 'hidden',
    hintClassName: '',
    type: 'Header',
    labelClassName: 'hidden',
    className: 'col-span-12',
    condition: (value) => value?.id,
  },
  {
    name: 'name',
    label: 'Name',
    placeholder: 'Enter laser profile name',
    type: 'Input',
    className: 'col-span-12',
    clear: false,
    reset: false,
    validation: Yup.string().required('Name is required'),
  },
  {
    name: 'description',
    label: 'Description',
    placeholder: 'Enter description',
    type: 'Input',
    className: 'col-span-12',
    clear: false,
    reset: false,
  },
  {
    label: `Hatch Patterns (${value?.hatch_patterns?.length})`,
    labelClassName: 'hidden',
    type: 'Divider',
    className: 'col-span-12',
  },
  {
    name: 'hatch_patterns',
    labelClassName: 'hidden',
    type: 'Module',
    module: HatchPatternList,
    className: 'col-span-12',
    defaultValue: [],
    //condition: (value)=> value?.hatch_patterns?.length > 0,
    validation: Yup.mixed().test(
      'is-array',
      'At least one item is required.',
      (value) => Array.isArray(value) && value.length > 0
    ),
  },
  {
    name: 'add_hatch_patterns',
    label: '+',
    type: 'PopUp',
    labelClassName: 'hidden',
    module: HatchPattern,
    view: ({ show }) => (
      <Button type={'alt'} className={'font-icon-solid !h-[37px] w-[37px]'} onClick={show}>
        +
      </Button>
    ),
    defaultValue: {},
    create: true,
    innerClassName: 'w-[450px]',
    className: '',
  },
  {
    name: 'divider',
    type: 'Divider',
    className: 'col-span-12',
  },
]

export default formView
